export default "__VITE_ASSET__eH1l_ZKz__"